import { render, staticRenderFns } from "./EditarItemOdontologia.vue?vue&type=template&id=4603cc9c"
import script from "./EditarItemOdontologia.vue?vue&type=script&lang=js"
export * from "./EditarItemOdontologia.vue?vue&type=script&lang=js"
import style0 from "./EditarItemOdontologia.vue?vue&type=style&index=0&id=4603cc9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports